var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChat = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 12C17.0156 12.2812 16.9062 12.5156 16.6875 12.7031C16.5 12.8906 16.2656 12.9844 15.9844 12.9844H6L2.01562 17.0156V3C2.01562 2.71875 2.10938 2.48438 2.29688 2.29688C2.48438 2.10938 2.71875 2.01562 3 2.01562H15.9844C16.2656 2.01562 16.5 2.10938 16.6875 2.29688C16.9062 2.48438 17.0156 2.71875 17.0156 3V12ZM21 6C21.2812 6 21.5156 6.09375 21.7031 6.28125C21.8906 6.46875 21.9844 6.70312 21.9844 6.98438V21.9844L18 18H6.98438C6.70312 18 6.46875 17.9062 6.28125 17.7188C6.09375 17.5312 6 17.2969 6 17.0156V15H18.9844V6H21Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat.e6b9f526.svg";
export { ForwardRef as ReactComponent };